import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link, Redirect } from 'react-router-dom';

import { RaffleContentWrap, ContentTopBottom, ContentCenter, P, ButtonDone, WrappImage } from './styled';
class RaffleSuccess extends React.Component {
  render() {
    const { state } = this.props.location;
    if (state === undefined) {
      return <Redirect to="/promo/reactxdisruptor" />
    }
    return (
      <RaffleContentWrap>
        <ContentTopBottom>
          <P>
            We have received your entry.
            Winners will be picked at random and
            be informed via email.
            Good Luck!
          </P>
        </ContentTopBottom>
        {/* <ContentCenter> */}
          {/* <WrappImage>
            <KickImage
              style={{ width: '100%', height: '100%' }}
              src={state.urlImage}
            />
          </WrappImage> */}
        {/* </ContentCenter> */}
        <ContentTopBottom>
          {/* <Link to="/" style={{ width: '70%' }}> */}
            <ButtonDone onClick={e=>this.props.history.push('/')}>
              {/* <P></P> */}
              BACK TO kickavenue.com
            </ButtonDone>
          {/* </Link> */}
        </ContentTopBottom>
      </RaffleContentWrap>
  )
  }
}

export default RaffleSuccess;
